// Simple cache service for dashboard using localStorage
class CacheService {
  constructor() {
    this.prefix = 'dashboard_cache_';
    this.defaultTTL = 5 * 60 * 1000; // 5 minutes
  }

  /**
   * Get value from cache
   */
  get(key) {
    try {
      const item = localStorage.getItem(this.prefix + key);
      if (!item) return null;

      const { value, expiresAt } = JSON.parse(item);
      
      // Check if expired
      if (Date.now() > expiresAt) {
        this.delete(key);
        return null;
      }

      return value;
    } catch (error) {
      console.error('Error reading from cache:', error);
      return null;
    }
  }

  /**
   * Set value in cache
   */
  set(key, value, ttl = this.defaultTTL) {
    try {
      const expiresAt = Date.now() + ttl;
      const item = {
        value,
        expiresAt,
      };
      localStorage.setItem(this.prefix + key, JSON.stringify(item));
    } catch (error) {
      console.error('Error writing to cache:', error);
      // If storage is full, clear old items
      this.clearExpired();
      try {
        localStorage.setItem(this.prefix + key, JSON.stringify({ value, expiresAt: Date.now() + ttl }));
      } catch (e) {
        console.error('Failed to cache after cleanup:', e);
      }
    }
  }

  /**
   * Delete value from cache
   */
  delete(key) {
    try {
      localStorage.removeItem(this.prefix + key);
    } catch (error) {
      console.error('Error deleting from cache:', error);
    }
  }

  /**
   * Clear all cache
   */
  clear() {
    try {
      const keys = Object.keys(localStorage);
      keys.forEach(key => {
        if (key.startsWith(this.prefix)) {
          localStorage.removeItem(key);
        }
      });
    } catch (error) {
      console.error('Error clearing cache:', error);
    }
  }

  /**
   * Clear expired items
   */
  clearExpired() {
    try {
      const keys = Object.keys(localStorage);
      const now = Date.now();
      keys.forEach(key => {
        if (key.startsWith(this.prefix)) {
          try {
            const item = JSON.parse(localStorage.getItem(key));
            if (item && item.expiresAt && now > item.expiresAt) {
              localStorage.removeItem(key);
            }
          } catch (e) {
            // Invalid item, remove it
            localStorage.removeItem(key);
          }
        }
      });
    } catch (error) {
      console.error('Error clearing expired cache:', error);
    }
  }

  /**
   * Check if key exists and is valid
   */
  has(key) {
    return this.get(key) !== null;
  }
}

export default new CacheService();















